import { Button, Modal, NestedSelectableTable, TextInput } from "@enpowered/ui";
import React, { useState } from "react";

import AddBillModal from "./add-bill-modal";
import DeleteBillModal from "./delete-bill-modal";
import error from "./error-white.svg";
import download from "./file-download-black.svg";
import MalformedBillModal from "./malformed-bill-modal";
import RunCalculationsModal from "./run-calculations-modal";
import runningWhite from "./running-white.svg";
import running from "./running.svg";

const BillManagementPageBody = () => {
  const [showAddBill, setShowAddBill] = useState(false);
  const [showRunCalculations, setShowRunCalculations] = useState(false);
  const [showDeleteBill, setShowDeleteBill] = useState(false);
  const [showFailBill, setShowFailBill] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchText, setSearchText] = useState("");

  // Bill modal
  const handleAddBillClick = () => {
    setShowAddBill(true);
  };

  const handleAddBillSubmit = (values, formikBag) => {
    console.log(formikBag);
    // We will be calling setSubmitting here to indicate on the form when we are submitting to get a spinner properly
    console.log(values);
    setShowAddBill(false);
    formikBag.resetForm();
  };

  const closeAddBillModal = () => {
    setShowAddBill(false);
  };

  // Run metrics modal
  const handleRunCalculationsClicked = () => {
    setShowRunCalculations(true);
  };

  const closeRunCalculationsModal = () => {
    setShowRunCalculations(false);
  };

  const handleRunCalculationsRun = () => {
    console.log("RUN IT");
    setShowRunCalculations(false);
  };

  // Fail Bill modal
  const handleFailBillClicked = () => {
    setShowFailBill(true);
  };

  const closeFailBillModal = () => {
    setShowFailBill(false);
  };

  const handleFailBillFail = () => {
    console.log("Fail it");
    setShowFailBill(false);
  };

  // Delete bill modal
  const handleDeleteBillClicked = () => {
    setShowDeleteBill(true);
  };

  const closeDeleteBillModal = () => {
    setShowDeleteBill(false);
  };

  const handleDeleteBillConfrim = () => {
    console.log("Delete selected bills");
    setShowDeleteBill(false);
  };

  // earthDownload
  const handleEarthDownloadClicked = () => {
    console.log("download earth file");
  };

  // Search box
  const handleSearchChange = e => {
    setSearchText(e.target.value);
  };

  const statusActionMap = {
    "Data Received": (
      <>
        <Button
          size="narrow"
          className="pl-2 pr-2 mr-1"
          onClick={handleEarthDownloadClicked}
        >
          <img src={download} width="21px" />
        </Button>
        <Button
          theme=""
          className="bg-black pl-2 pr-2  mr-1"
          size="narrow"
          onClick={handleRunCalculationsClicked}
        >
          <img src={runningWhite} />
        </Button>
        <Button
          theme=""
          className=" bg-red-600 pl-2 pr-2"
          size="narrow"
          onClick={handleFailBillClicked}
        >
          <img src={error} width="21px" />
        </Button>
      </>
    ),
    "Running Metrics": (
      <Button
        theme=""
        className="bg-gray-500 text-black flex hover:shadow-none"
        size="narrow"
      >
        <img src={running} /> <span className="pl-1">Running</span>
      </Button>
    ),
    Completed: <Button size="narrow">Download</Button>,
    "Request Submitted": <div />
  };

  const rows = [
    {
      id: "row-1",
      columns: [
        "Fake Account 1",
        new Date().toDateString(),
        "Data Received",
        () => statusActionMap["Data Received"] || <div />
      ]
    },
    {
      id: "row-2",
      columns: [
        "Fake Account 2",
        new Date().toDateString(),
        "Running Metrics",
        () => statusActionMap["Running Metrics"] || <div />
      ]
    },
    {
      id: "row-3",
      columns: [
        "Fake Account 3",
        new Date().toDateString(),
        "Completed",
        () => statusActionMap["Completed"] || <div />
      ]
    },
    {
      id: "row-4",
      columns: [
        "Fake Account 4",
        new Date().toDateString(),
        "Request Submitted",
        () => statusActionMap["Request Submitted"] || <div />
      ]
    }
  ];

  const handleRowSelected = ([rowId]) => {
    selectedRows.includes(rowId)
      ? setSelectedRows(selectedRows.filter(id => id !== rowId && id !== "all"))
      : setSelectedRows([...selectedRows, rowId]);
  };

  const handleSelectAll = allSelected => {
    allSelected
      ? setSelectedRows(["all", ...rows.map(row => row.id)])
      : setSelectedRows([]);
  };

  return (
    <>
      {/* Add Bill */}
      <Modal isOpen={showAddBill} onClose={closeAddBillModal} title="Add Bill">
        <AddBillModal
          onSubmit={handleAddBillSubmit}
          onCancel={closeAddBillModal}
        />
      </Modal>
      {/* Run Calcs */}
      <Modal
        isOpen={showRunCalculations}
        onClose={closeRunCalculationsModal}
        title="Run Calculations"
      >
        <RunCalculationsModal
          onRun={handleRunCalculationsRun}
          onCancel={closeRunCalculationsModal}
        />
      </Modal>
      {/* Fail Bill */}
      <Modal isOpen={showFailBill} onClose={closeFailBillModal} title="Failed">
        <MalformedBillModal
          onFail={handleFailBillFail}
          onCancel={closeFailBillModal}
        />
      </Modal>
      {/* Delete Bill */}
      <Modal
        isOpen={showDeleteBill}
        onClose={closeDeleteBillModal}
        title="Delete Bill"
      >
        <DeleteBillModal
          onConfirm={handleDeleteBillConfrim}
          onCancel={closeDeleteBillModal}
          isDeleting={false} // This will be controlled by the mutation
        />
      </Modal>
      <div className="mx-12 pt-6 pb-4 px-4 w-full bg-white border-2 rounded-md border-en-gray-100 overflow-hidden">
        <div className="flex justify-between mb-4">
          <TextInput placeholder="Search" onChange={handleSearchChange} />
          <div className="flex items-center">
            {selectedRows.length > 0 && (
              <Button
                className="bg-white text-black border border-gray-800 rounded mr-4"
                theme=""
                size="narrow"
                onClick={handleDeleteBillClicked}
              >
                Delete Bill
              </Button>
            )}
            <Button
              className="bg-black text-white"
              theme=""
              size="narrow"
              onClick={handleAddBillClick}
            >
              Add Bill
            </Button>
          </div>
        </div>
        <div>
          <NestedSelectableTable
            headings={["Account Name", "Date Added", "Status", "Action"]}
            rows={rows}
            className="text-left"
            onChange={handleRowSelected}
            onToggleSelectAll={handleSelectAll}
            selectedRows={selectedRows}
            searchText={searchText}
          />
        </div>
      </div>
    </>
  );
};

export default BillManagementPageBody;
